import {useState} from "react";
import {useServerData} from "../request";

const genericErrorMessages = {
  doesNotExist: "invalid token, please check whether this is the correct link",
  isAlreadyUsed: "this token has been used already",
  tooOld: "this token is too old. Please request a new one!",
  deleted: "the email address has been deleted or changed!",
};

const useToken = ({token, url, errorMessages, onDone}) => {
  const [error, setError] = useState(null);
  const {isLoaded, data} = useServerData({
    method: "POST",
    path: url,
    data: {token},
    dataKey: token,
    onSuccess: onDone,
    onError: (msg) =>
      setError((errorMessages && errorMessages[msg]) || genericErrorMessages[msg] || msg),
  });

  return {isLoading: !isLoaded, data, error};
};

export default useToken;
